<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list
      :filters="filters"
      :include="[
        'livestock_type_entity',
        'livestock_operation_entity',
        'barn_type_entity',
      ]">
      <va-data-table :fields="fields" disable-clone> </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
export default {
  props: ['resource', 'title'],
  data() {
    return {
      filters: [],
      fields: [
        {
          source: 'livestock_type_entity.class',
          type: 'select',
          attributes: { reference: 'livestock_types', chip: true },
        },
        { source: 'livestock_num', type: 'number', sortable: true },
        {
          source: 'livestock_operation_entity.livestock_operation',
          type: 'select',
          attributes: { reference: 'livestock_operations', chip: true },
        },
        { source: 'barn_time', type: 'number', sortable: true },
      ],
    }
  },
}
</script>
